import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function HotPicks() {
  const picks = [...articles].sort((a, b) => b.popularity - a.popularity).slice(4, 10);

  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Best Picks</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门搭配推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">来自读者反馈与阅读数据精选的高人气搭配指南。</p>
        </div>
        <Link
          to="/categories"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          更多搭配 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {picks.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}